export default function SvgMessage3() {
    return (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35px"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="#00cc00"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M16 10h.01M12 10h.01M8 10h.01M3 10c0-5.353 2.118-7 9-7s9 1.647 9 7-2.118 7-9 7c-.34 0-.67-.004-.988-.012L7 21v-4.506C4.033 15.669 3 13.738 3 10z"
          ></path>
        </svg>
      </>
    );
  }
